import { configureStore, combineReducers } from "@reduxjs/toolkit";
import stateReducer from "./Slices/stateSlice";
import cityReducer from "./Slices/citySlice";
import pincodeReducer from "./Slices/pincodeSlice";
import storeReducer from "./Slices/storeSlice";
import navbarReducer from "./Slices/navbarTitleSlice";
import productReducer from "./Slices/productSlice";
import categoryReducer from './Slices/categorySlice';
import transactionsReducer from './Slices/transactionsSlice';
import attributeReducer from './Slices/attributesSlice';
import layoutReducer from './Slices/layoutSlice';
import { setStoreRef } from "../service/FCM/storeRef";
import orderReducer from './Slices/orderSlice';
import loaderReducer from './Slices/loaderSlice';
import { setAppDispatch } from "./Utils/loaderDispatcher";
import organizationReducer from "./Slices/organizationSlice";
import roleAndPermissionReducer from "./Slices/permissionsSlice";
import userRegistrationReducer from "./Slices/userRegistrationSlice";
import popularProductReducer from "./Slices/popularProductSlice"
import tabReducer from "./Slices/tabSlice";
import settlementTabReducer from "./Slices/settlementTabSlice";
// Add new imports
import fcmReducer from "./Slices/fcmSlice";
import notificationReducer from "./Slices/notificationSlice";
import orderNotificationSettingsReducer from "./Slices/orderNotificationSettingsSlice";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  // Don't persist FCM token and notification state as they should be regenerated on each load
  blacklist: ['fcm', 'notification'],
};

const rootReducer = combineReducers({
  states: stateReducer,
  cities: cityReducer,
  pincodes: pincodeReducer,
  store: storeReducer,
  navbar: navbarReducer,
  product: productReducer,
  category: categoryReducer,
  attributes: attributeReducer,
  transactions: transactionsReducer,
  layout: layoutReducer,
  orders: orderReducer,
  loader: loaderReducer,
  organization: organizationReducer,
  roleAndPermission: roleAndPermissionReducer,
  userRegistration: userRegistrationReducer,
  popularProduct: popularProductReducer,
  tab: tabReducer,
  settlementTab: settlementTabReducer,
  // Add new reducers
  fcm: fcmReducer,
  notification: notificationReducer,
  orderNotificationSettings: orderNotificationSettingsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

setStoreRef(store);
export const persistor = persistStore(store);

setAppDispatch(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

